exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".component-header {\n  z-index: 100;\n  height: 80px;\n  padding: 20px;\n  background-color: #363874;\n  position: fixed;\n  top: 0;\n  width: 100%; }\n  .component-header .logo {\n    height: 60px; }\n  .component-header .search-input {\n    margin-left: 40px;\n    max-width: 545px; }\n", ""]);

